module.exports = __webpack_public_path__ + "img/ipside-grey.000b2136.png";